import { RouterState } from 'mobx-state-router';
import { isSome, checkBuildVersion } from 'core/utils';
import _ from 'lodash';

async function extendRouterStore(routerStore, historyAdapter) {
	const history = historyAdapter;
	const buildVersionThrottle = await checkBuildVersion();

	routerStore.goBack = function(defaultRouteName) {
		const { routeHistory } = routerStore;
		const idx = routeHistory.length - 2;
		if (idx < 0 && defaultRouteName) {
			routerStore.originalGoTo(new RouterState(defaultRouteName));
		} else {
			history.goBack();
		}
	};
	routerStore.originalGoTo = routerStore.goTo;
	routerStore.goTo = (routeName, params1, params2) => {
		buildVersionThrottle();
		routerStore.originalGoTo(routeName, params1, params2);
	};

	routerStore.originalTransition = routerStore.transition;

	routerStore.transition = async (fromState, toState) => {
		let {
			rootStore: { errorStore },
		} = routerStore;
		if (isSome(errorStore.internalException)) {
			throw errorStore.internalException;
		} else {
			return await routerStore.originalTransition(fromState, toState);
		}
	};

	routerStore.setQueryParams = params => {
		return routerStore.silentTransition(routerStore.getCurrentRoute().name, params);
	};

	routerStore.updateQueryParams = params => {
		var currentRoute = routerStore.getCurrentRoute();

		var toRoute = routerStore.routeHistory.length === 0 ? routerStore.rootStore.initialState : currentRoute.name;
		return routerStore.silentTransition(toRoute, { ...routerStore.routerState.queryParams, ...params });
	};

	routerStore.silentTransition = (route, params) => {
		routerStore.isSilentTransition = true;
		return routerStore.originalGoTo(route, routerStore.routerState.params, params).then(() => {
			routerStore.isSilentTransition = false;
		});
	};
}

export default extendRouterStore;
